<template></template>
<script>

  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import SettingsContainer from '@/helper/SettingsContainer';

  export default {
    name: 'SettingsSetter',
    data() {
      return {
        };
    },
    mounted() {
      console.log("SettingsSetter");
      const modul = this;
      this.getSettings();
//      modul.$eventBus.$on('globalSetBusinessPartner', this.globalSetBusinessPartnerEventHandler);
    },
    beforeDestroy() {
//      this.$eventBus.$off('globalSetBusinessPartner');
    },
    methods: {
      getSettings(){
        const modul = this;
//        Api.getSettings().then(function (res) {
//          if (res && res.result) {
//            SettingsContainer.setSettings(Array.from(res.data));
//            Helper.updateSettings();
//          }
//        });
      },
    },
    components: {
      Api,
      SettingsContainer,
    },
  };
</script>
